// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-container {
  width: 100vw;
  height: 100vh;
  padding-top: 100px;
  padding-bottom: 100px;
}

.git-btn {
  padding: 8px 64px !important;
  height: 56px !important;
}`, "",{"version":3,"sources":["webpack://./src/routes/mobile-error/style.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;AACF;;AAEA;EACE,4BAAA;EACA,uBAAA;AACF","sourcesContent":[".error-container{\n  width: 100vw;\n  height: 100vh;\n  padding-top: 100px;\n  padding-bottom: 100px;\n}\n\n.git-btn{\n  padding: 8px 64px !important;\n  height: 56px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
